<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('shipments.services', 1)"
    class="shipment-service-filter w-2"
    optional
  >
    <ServiceMultiSelect :id="inputId" v-model="selectedServiceLevels" />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';
import { ServiceLevel } from '@rygen/rygen-ui/model';
import { notNull } from '@rygen/rygen-ui/util';

import { ShipmentSearchCriteria } from '@/model';
import { useServiceLevelStore } from '@/stores/ServiceLevel';

import ServiceMultiSelect from '@/components/shipment/ServiceMultiSelect.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipmentSearchCriteria,
    default: () => new ShipmentSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipmentSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipmentSearchCriteria>) =>
    new ShipmentSearchCriteria(opts),
});
const { serviceLevels } = useServiceLevelStore();

const selectedServiceLevels = computed<ServiceLevel[]>({
  get: () =>
    internalValue.value.services
      .map((name) => serviceLevels.value.data?.find((s) => s.name === name))
      .filter(notNull),
  set: (levels) => {
    internalValue.value.services = levels
      .map((l) => l.name)
      .filter((n): n is string => n != null);
  },
});
</script>
